module.exports = __webpack_public_path__ + "f1a2e927ec4caa11793c65e2689001ec.otf";